<template>
  <div :class="['home', hoverTarget]">
    <div
      :class="[
        'logo',
        hoverTarget === 'torolab' && 'selected',
        hoverTarget === 'dam-2023' && 'hidden'
      ]"
      @mouseover="setHoverTarget('torolab')"
      @mouseleave="clearHoverTarget">
      <img src="@/assets/images/torolab-logo.svg">
    </div>
    <div class="separator"/>
    <div
      :class="[
        'logo',
        hoverTarget === 'dam-2023' && 'selected',
        hoverTarget === 'torolab' && 'hidden'
      ]"
      @mouseover="setHoverTarget('dam-2023')"
    >
      <img src="@/assets/images/dam-2023-logo.svg">
    </div>
    <div :class="['floater', 'torolab', hoverTarget === 'torolab' && 'selected']">
      <div
        :style="blackStroke"
        class="quote quote-text">Torolab trabaja con las ideas de otras personas de como vivir mejor</div>
      <div class="quote quote-author">-Raúl Darío Cárdenas Osuna</div>
    </div>
    <div :class="['floater', 'dam-2023', hoverTarget === 'dam-2023' && 'selected']">
      <div
        :style="whiteStroke"
        class="quote quote-text">
        <p>Diseño y emprendimiento para un futuro más justo</p>
        <p>Design and entrepreneurship for a fairer future</p>
        <div class="blocks">
          <a href="https://torolab-web.s3.amazonaws.com/dam-2023-convocatoria.pdf">
            Convocatoria
          </a>
          <a href="https://torolab-web.s3.amazonaws.com/dam-2023-open-call.pdf">
            Open Call
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: function() {
    var ua = navigator.userAgent.toLowerCase();
    const isSafari = ua.indexOf('safari') != -1 && ua.indexOf('chrome') === -1;
    const strokeWidth = isSafari ? 0.4 : 0.2;
    return {
      hoverTarget: '',
      blackStroke: { '-webkit-text-stroke': strokeWidth + 'vmin white' },
      whiteStroke: { '-webkit-text-stroke': strokeWidth + 'vmin black' }
    };
  },
  methods: {
    setHoverTarget(hoverTarget) {
      this.hoverTarget = hoverTarget;
    },
    clearHoverTarget() {
      this.hoverTarget = '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/colors';
.home {
  display: flex;
  transition: background-position 1s ease-in-out, opacity 0.5s ease-in-out;
  background: linear-gradient(105deg, black 50%, $pale_taupe 50%);
  background-repeat: no-repeat;
  background-size: 200% 100%;
  background-position: 50%;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  &.dam-2023 {
    background-position: 100%;
  }
  &.torolab {
    background-position: 0%;
  }
}
.logo {
  position: relative;
  top: 50px;
  padding: 12vmin;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  z-index: 200;
  img {
    transition: transform 1s ease-in-out;
    height: 38vmin;
  }
  &.selected {
    img {
      transform: scale(1.1);
    }
  }
  &.hidden {
    opacity: 0;
  }
}
.separator {
  flex: 1;
}
.floater {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  opacity: 0;
  transition: opacity 0.75s ease-in-out;
  display: flex;
  flex-direction: column;
  &.selected {
    opacity: 1;
  }
  &.dam-2023 {
    background-color: $light_taupe;
    background-size: 6vmin;
    & .quote.quote-text {
      color: $light_taupe;
      font-size: 6vmin;
    }
    & .quote.quote-author {
      color: black;
    }
    & .blocks {
      text-align: right;
      position: absolute;
      bottom: 8vw;
      right: 60vmin;
      & a {
        padding: 0.75vmin 2vmin 0;
        font-weight: 500;
        border-radius: 1vmin;
        text-transform: uppercase;
        display: block;
        background-color: $orange;
        -webkit-text-stroke: 0;
        color: $light_taupe;
        text-decoration: none;
        margin-top: 2vmin;
        text-align: center;
      }
    }
  }
  &.torolab {
    background-color: black;
    float: right;
    align-items: flex-end;
    text-align: right;
    & .quote.quote-text {
      color: black;
    }
    & .quote.quote-author {
      color: white;
    }
  }
  & .quote {
    font-family: 'TSTAR PRO';
    margin: 0 8vw 2vmin;
    text-rendering: optimizeLegibility;
    -webkit-hyphens: auto;
    hyphens: auto;
    &.quote-text {
      margin-top: 8vw;
      font-size: 8vmin;
      font-weight: 900;
      width: 50vw;
      text-overflow: ellipsis;
      & p {
        margin: 0 0 4vmin 0;
      }
    }
    &.quote-author {
      font-weight: 600;
      text-transform: uppercase;
      font-size: 3.5vmin;
      overflow: hidden;
      width: 50vw;
      text-align: right;
    }
  }
}
</style>
